import { Component, inject } from '@angular/core';
import { AppInformationService } from 'app/core/app-information.service';
import { GenesisUnitOfWork } from 'app/core/core.module';
import { ConfirmationPaymentMethod } from 'app/core/model/confirmation-payment-method';
import validationEngine from 'devextreme/ui/validation_engine';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-confirmation-payment-method-dialog',
    template: `
        <div class="modal-header">
            <h2 class="modal-title">Confirmation Payment Method</h2>
        </div>
        <div class="flex-fill d-flex flex-column">
            <div class="card">
                <div class="card-body">
                    <dx-form *ngIf="confirmationPaymentMethod" [formData]="confirmationPaymentMethod" validationGroup="confirmationPaymentMethodValidationGroup">
                        <dxi-item itemType="group">
                            <dxi-item dataField="name" [isRequired]="true"></dxi-item>
                            <dxi-item dataField="requiresAch" editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="requiresNorthpoint" editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="winterOrder" editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="visibleToChannelPartner" editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="paymentTerms" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-danger" (click)="save()">Save</button>
            <button type="button" class="btn btn-success" (click)="close()">Close</button>
        </div>
    `,
    standalone: false
})
export class ConfirmationPaymentMethodDialogComponent {
    appInfo = inject(AppInformationService);
    uow = inject(GenesisUnitOfWork);

    result = new Subject<{ success: boolean }>();
    confirmationPaymentMethod: ConfirmationPaymentMethod;
    displayOrder: number;

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        if (!this.confirmationPaymentMethod)
            this.confirmationPaymentMethod = this.uow.confirmationPaymentMethods.createEntity({
                displayOrder: this.displayOrder,
            }) as ConfirmationPaymentMethod;
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('confirmationPaymentMethodValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('confirmationPaymentMethodValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
